import React from "react";
import { Button, Card, Row, Space } from "antd";
import PropTypes from "prop-types";
import SelectInput from "components/form/inputs/selectInput";
import TAGS from "constants/tags";
import { observer } from "mobx-react";

function Utilities({ addTrialMinutes, updateTag, tag }) {
  return (
    <Card title="Utilities" style={{ width: "100vw" }}>
      <Row>
        <Space>
          <SelectInput
            onChange={updateTag}
            value={tag && tag.tag}
            placeholder="Add a tag"
            options={TAGS}
          />
          <Button type="primary" danger onClick={() => updateTag(null)}>
            Clear
          </Button>
        </Space>
      </Row>
      <Row>
        <Button
          type="primary"
          onClick={() => addTrialMinutes(3)}
          style={{ marginTop: 20 }}
        >
          Add free 3 minutes
        </Button>
      </Row>
      <Row>
        <Button
          type="primary"
          onClick={() => addTrialMinutes(5)}
          style={{
            marginTop: 20,
            backgroundColor: "#9400D3",
            borderColor: "#9400D3",
          }}
        >
          Add free 5 minutes
        </Button>
      </Row>
    </Card>
  );
}

Utilities.propTypes = {
  addTrialMinutes: PropTypes.func.isRequired,
};

export default observer(Utilities);
